import React, {useContext, useEffect} from 'react';
import {ImageRequestParams} from "../../../infrastructure/models/params/image-request-params";
import {BaseImage, BaseImageProps} from "./base-image";
import {ThemeContext} from "../../app/contexts/theme-context";
import {THEME} from "../../app/consts";
import {useFallbackRef} from "../../../infrastructure/hooks/useFallbackRef";

export class ImageProps extends BaseImageProps {
  src: ImageRequestParams;
  eager: Boolean;
  theme: THEME;
}

export const Image = React.forwardRef((props: ImageProps, forwardedRef) => {
  const ref = useFallbackRef(forwardedRef)
  const {src, eager, ...rest} = props;
  const theme = props.theme || useContext(ThemeContext);

  if (src instanceof ImageRequestParams) {
    src.theme = theme
  }

  useEffect(() => {
    if (src instanceof ImageRequestParams) {
      src.theme = theme
    }
  }, [theme]);

  const imageProps = {
    ...rest,
    width: null,
    height: null,
    alt: (props.alt) || src?.alt || '',
    title: (src && (src.title || src.alt)) || '',
    src: src?.toString(),
    ref,
    loading: eager ? 'eager' : 'lazy',
  };

  return <BaseImage {...imageProps}/>;
});
